<template>
  <div class="user-info">
    <div v-if="isWeifangTemplate" class="weifang-footer">
      <div>
        <p>医生签名：<span class="weifang-signature-space"></span></p>
        <p>报告日期：{{ model.createDate }}</p>
        <p>咨询电话：0536-5078356</p>
      </div>
    </div>
    <div class="user-info-top"
      v-else-if="model.reportTemplateType === 26 || model.reportTemplateType === 34 || isLinyiTemplate || isSanmingTemplate">
      <div class="user-info-top-left" :class="{ 'user-info-top-left-single': isLinyiTemplate || isSanmingTemplate }">
        <line-input :title="reporterTitle" :initalValue="model.initialOperator"
          :largeFontSize="model.reportTemplateType === 34" @onInput="onInputInput"></line-input>
        <p v-if="isSanmingTemplate" class="user-info-top-left-text reviewer-signature">
          审核者：<img
            src="https://bajie-sleep.oss-cn-hangzhou.aliyuncs.com/file/1789543201626.png"
            alt="审核者电子签名">
        </p>
        <line-input v-else-if="!isLinyiTemplate" :title="reviewerTitle" :initalValue="model.initialReviewer"
          :largeFontSize="model.reportTemplateType === 34" @onInput="onInputInput"></line-input>
        <button class="user-info-top-left-button noPrint" data-html2canvas-ignore="true" @click="onSaveClick">
          保存
        </button>
      </div>
      <div style="flex: 1"></div>
      <p class="user-info-top-right" v-if="model.reportTemplateType !== 34 && !isLinyiTemplate && !isSanmingTemplate">
        {{ model.createDate }}
      </p>
    </div>
    <div class="user-info-top" v-else-if="model.reportTemplateType === 43">
      <div class="user-info-top-left">
        <p class="user-info-top-left-text">
          操作者：<img
            src="https://bajie-sleep.oss-cn-hangzhou.aliyuncs.com/%E5%B9%BF%E5%B7%9E%E6%9A%A8%E5%8D%8E%E6%93%8D%E4%BD%9C%E8%80%85.jpg"
            alt="" style="height: 30px;"></img>
        </p>
      </div>
      <div class="user-info-top-left">
        <p class="user-info-top-left-text">
          报告医生：<img
            src="https://bajie-sleep.oss-cn-hangzhou.aliyuncs.com/%E5%B9%BF%E5%B7%9E%E6%9A%A8%E5%8D%8E%E6%8A%A5%E5%91%8A%E5%8C%BB%E7%94%9F.jpg"
            alt="" style="height: 30px;">
        </p>
      </div>
      <p class="user-info-top-right">
        报告日期：<span class="bottom-line">{{ model.createDate }}</span>
      </p>
    </div>
    <div class="user-info-top" v-else-if="model.reportTemplateType === 47">
      <div style="flex: 1"></div>
      <p class="user-info-top-left-text" style="margin-right: 40px;">
        报告：<span class="bottom-line">张方圆</span>
      </p>
      <p class="user-info-top-left-text" style="margin-right: 40px;">
        审核：<span class="bottom-line">叶焕荣</span>
      </p>
      <p class="user-info-top-right">
        报告日期：<span class="bottom-line">{{ model.createDate }}</span>
      </p>
    </div>
    <div v-else-if="model.reportTemplateType === 45">
      <div class="user-info-top-left" style="flex-direction: row;">
        <div style="flex: 1"></div>
        <line-input title="审核" :initalValue="model.initialReviewer"
          :largeFontSize="true" @onInput="onInputInput"></line-input>
        <button class="user-info-top-left-button noPrint" data-html2canvas-ignore="true" @click="onSaveClick">
          保存
        </button>
      </div>
    </div>
  </div>
</template>



<script>
import LineInput from "@c/report-detail/user-info/line-input.vue";
import NewLineInput from "@c/report-detail/user-info/new-line-input.vue";
export default {
  components: {
    LineInput,
    NewLineInput,
  },

  props: {
    model: Object,
  },
  computed: {
    isWeifangTemplate() {
      return this.model.reportTemplateType === REPORT_TEMPLATE.潍坊市奎文区新华医院;
    },
    isLinyiTemplate() {
      return this.model.reportTemplateType === REPORT_TEMPLATE.临沂市中心医院精神卫生科;
    },

    isSanmingTemplate() {
      return this.model.reportTemplateType === REPORT_TEMPLATE.三明市第二医院;
    },

    reviewerTitle() {
      return this.model.reportTemplateType === 34 ? "审核者" : "审核";

    },

    reporterTitle() {
      return this.model.reportTemplateType === 34 || this.isSanmingTemplate ? '检查者' : '报告'
    },
  },

  methods: {
    onInputInput(title, value) {
      this.$emit("onInputInput", title, value);
    },
    onSaveClick() {
      this.$emit("onSaveClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  margin-bottom: rem(20);
  margin-top: rem(20);

  &-top {
    height: rem(40);
    margin-top: rem(10);
    margin-bottom: rem(10);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-left {
      display: flex;
      align-items: center;

      .line-input {
        width: 27%;
      }

      &-button {
        color: white;
        background-color: #16d585;
        font-size: rem(12);
        border-radius: rem(4);
        width: rem(50);
        height: rem(25);
        margin-left: rem(20);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-single {
        .line-input {
          flex-shrink: 0;
          width: rem(133);
        }
      }

      &-text {
        color: black;
        font-size: rem(14);
        margin-right: rem(12);
        white-space: nowrap;

        img {
          border-bottom: 1px solid #333;
        }
      }
    }

    &-left-wide {
      display: flex;
      align-items: center;
      margin-left: auto;

      .line-input {
        width: 27%;
      }

      &-button {
        color: white;
        background-color: #16d585;
        font-size: rem(12);
        border-radius: rem(4);
        width: rem(50);
        height: rem(25);
        margin-left: rem(20);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &-left-extra-wide {
      display: flex;
      align-items: center;

      .line-input {
        width: 50%;
      }

      &-button {
        color: white;
        background-color: #16d585;
        font-size: rem(12);
        border-radius: rem(4);
        width: rem(50);
        height: rem(25);
        margin-left: rem(20);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &-right {
      color: black;
      font-size: rem(14);
      margin-right: rem(12);
      white-space: nowrap;
    }
  }
}

.bottom-line {
  border-bottom: 1px solid #333;
}

.weifang-footer {
  display: flex;
  justify-content: flex-end;
  margin-right: rem(12);
  color: black;
  font-size: rem(14);
  line-height: rem(30);
  break-inside: avoid;
  page-break-inside: avoid;

  .weifang-signature-space {
    display: inline-block;
    width: rem(140);
  }
}

.reviewer-signature {
  display: flex;
  align-items: center;
  margin-left: rem(20);

  img {
    width: auto;
    height: rem(30);
    object-fit: contain;
  }
}

@media print {
  .noPrint {
    display: none;
    background-color: white !important;
  }
}
</style>
